// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
    scroll-behavior: smooth;
}

* {
    box-sizing: border-box;
}

a {
    text-decoration: none;
}

a:hover {
    /* color: #35a8d8; */

    /* color: rgba(20, 137, 181, 0.76); */
}

input {
    margin: 0;
    border: none;
    border-radius: 0;
    outline: none;
    font-family: 'Open Sans', sans-serif;
}

@supports (-webkit-touch-callout: none) {
    body {
        /* --app-height: 100dvh; */
    }
}

::-webkit-scrollbar {
    width: 0;
}

img {
    -webkit-user-drag: none;
}
`, "",{"version":3,"sources":["webpack://./src/css/main/general.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;;IAEpB,qCAAqC;AACzC;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,oCAAoC;AACxC;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,uBAAuB;AAC3B","sourcesContent":["html {\n    scroll-behavior: smooth;\n}\n\n* {\n    box-sizing: border-box;\n}\n\na {\n    text-decoration: none;\n}\n\na:hover {\n    /* color: #35a8d8; */\n\n    /* color: rgba(20, 137, 181, 0.76); */\n}\n\ninput {\n    margin: 0;\n    border: none;\n    border-radius: 0;\n    outline: none;\n    font-family: 'Open Sans', sans-serif;\n}\n\n@supports (-webkit-touch-callout: none) {\n    body {\n        /* --app-height: 100dvh; */\n    }\n}\n\n::-webkit-scrollbar {\n    width: 0;\n}\n\nimg {\n    -webkit-user-drag: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
